import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({
    title = 'SAFECARE - National Health Plan',
    description = 'A comprehensive national health plan that covers everyone. One national promise. Everybody in. Nobody dropped when life changes.',
    image = '/image/0_blueprint_hero.jpg',
    type = 'website'
}) => {
    const location = useLocation();
    const domain = 'https://safecplus.org';
    const url = `${domain}${location.pathname}`;

    useEffect(() => {
        // Update document title
        document.title = title;

        // Remove existing meta tags
        const existingMetas = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"], meta[name="description"]');
        existingMetas.forEach(meta => meta.remove());

        // Remove existing canonical
        const existingCanonical = document.querySelector('link[rel="canonical"]');
        if (existingCanonical) existingCanonical.remove();

        // Create meta tags
        const metaTags = [
            // Standard meta
            { name: 'description', content: description },

            // Open Graph
            { property: 'og:title', content: title },
            { property: 'og:description', content: description },
            { property: 'og:image', content: `${domain}${image}` },
            { property: 'og:url', content: url },
            { property: 'og:type', content: type },
            { property: 'og:site_name', content: 'SAFECARE' },

            // Twitter Card
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: title },
            { name: 'twitter:description', content: description },
            { name: 'twitter:image', content: `${domain}${image}` },
        ];

        // Add meta tags to head
        metaTags.forEach(({ name, property, content }) => {
            const meta = document.createElement('meta');
            if (name) meta.setAttribute('name', name);
            if (property) meta.setAttribute('property', property);
            meta.setAttribute('content', content);
            document.head.appendChild(meta);
        });

        // Add Canonical Link
        const link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', url);
        document.head.appendChild(link);

        // Add Structured Data (JSON-LD)
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.innerHTML = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": domain
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": title,
                    "item": url
                }
            ]
        });
        document.head.appendChild(script);

        // Cleanup function
        return () => {
            const metas = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]');
            metas.forEach(meta => meta.remove());
            if (link) link.remove();
            if (script) script.remove();
        };
    }, [title, description, image, url, type, domain]);

    return null;
};

export default SEO;
